import type { ShareAuthCheckData } from '../types';

export const ShareAccessCheckApi = Symbol('ShareAccessCheckApi');

export interface ShareAccessCheckApi {
  shareAccessCheckForGuest(inData?: ShareAuthCheckData): Promise<boolean>;
  shareAccessCheck(inData?: ShareAuthCheckData): Promise<boolean>;
}
